export default {
  addingTodo: false,
  loading: true,
  requiresAlertTodos: false,
  categories: [],
  todos: [],
  authState: "login"
};
